import { FullCLesson } from '@yandex-int/k-common';
// @ts-ignore
import { PROBLEM_TYPES } from '@yandex-int/k-common/constants';
import { useState } from 'react';
import { useIntl } from 'react-intl';
import { useDispatch } from 'react-redux';

import { actions as lessonActions } from 'common.components/lesson';

export type CreateLessonCallback = (
    params: {
        problems: { id: number }[];
        lessonName: string;
        lessonMeta?: string;
    },
    onSuccess: (clessonId: number, clessonData: FullCLesson) => void
) => void;

// FIXME надо бы выдавать диагностику и рекомендации одной ручкой
// (той что сейчас диагностика выдается - c ней работает lessonMeta)
export const useCreateLesson = (params?: { isDiagnostic?: boolean }) => {
    const isDiagnostic = params?.isDiagnostic;

    const dispatch = useDispatch();
    const intl = useIntl();
    const [isLessonCreationInProgress, setLessonCreationInProgress] = useState(false);

    const createLesson: CreateLessonCallback = ({ problems, lessonName, lessonMeta }, onSuccess) => {
        if (!problems) {
            return;
        }

        const lessonProblemLinks = problems.map((problem) => ({
            type: PROBLEM_TYPES.PROBLEM,
            problem,
        }));

        setLessonCreationInProgress(true);

        dispatch(
            lessonActions.insertProblems({
                index: 0,
                problems: lessonProblemLinks,
            })
        );

        if (isDiagnostic) {
            dispatch(
                lessonActions.createLessonByProblemIds({
                    intl,
                    lessonName,
                    lessonMeta,
                    problemIds: problems.map(({ id }) => id),
                    onSuccess: (clessonId, clessonData) => {
                        onSuccess(clessonId, clessonData);

                        setLessonCreationInProgress(false);
                    },
                })
            );
        } else {
            dispatch(
                lessonActions.saveOrCreateLesson({
                    intl,
                    lessonName,
                    lessonMeta,
                    onSuccess: (clessonId, clessonData) => {
                        onSuccess(clessonId, clessonData);

                        setLessonCreationInProgress(false);
                    },
                })
            );
        }
    };

    return { isLessonCreationInProgress, createLesson };
};
